// Copyright (c) 2015, Frappe Technologies Pvt. Ltd. and Contributors
// License: GNU General Public License v3. See license.txt

// shopping cart
frappe.provide("aracwebshop.aracwebshop.shopping_cart");
var shopping_cart = aracwebshop.aracwebshop.shopping_cart;

var getParams = function (url) {
	var params = [];
	var parser = document.createElement('a');
	parser.href = url;
	var query = parser.search.substring(1);
	var vars = query.split('&');
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=');
		params[pair[0]] = decodeURIComponent(pair[1]);
	}
	return params;
};

frappe.ready(function() {
	var full_name = frappe.session && frappe.session.user_fullname;
	// update user
	if(full_name) {
		$('.navbar li[data-label="User"] a')
			.html('<i class="fa fa-fixed-width fa fa-user"></i> ' + full_name);
	}
	// set coupon code and sales partner code

	var url_args = getParams(window.location.href);

	var referral_coupon_code = url_args['cc'];
	var referral_sales_partner = url_args['sp'];

	var d = new Date();
	// expires within 30 minutes
	d.setTime(d.getTime() + (0.02 * 24 * 60 * 60 * 1000));
	var expires = "expires="+d.toUTCString();
	if (referral_coupon_code) {
		document.cookie = "referral_coupon_code=" + referral_coupon_code + ";" + expires + ";path=/";
	}
	if (referral_sales_partner) {
		document.cookie = "referral_sales_partner=" + referral_sales_partner + ";" + expires + ";path=/";
	}
	referral_coupon_code=frappe.get_cookie("referral_coupon_code");
	referral_sales_partner=frappe.get_cookie("referral_sales_partner");

	if (referral_coupon_code && $(".tot_quotation_discount").val()==undefined ) {
		$(".txtcoupon").val(referral_coupon_code);
	}
	if (referral_sales_partner) {
		$(".txtreferral_sales_partner").val(referral_sales_partner);
	}

	// update login
	shopping_cart.show_shoppingcart_dropdown();
	shopping_cart.set_cart_count();
	shopping_cart.show_cart_navbar();
	shopping_cart.bind_add_to_cart_action();
});

$.extend(shopping_cart, {
	show_shoppingcart_dropdown: function() {
		$(".shopping-cart").off('shown.bs.dropdown.shopping_cart_menu').on('shown.bs.dropdown.shopping_cart_menu', function() {
			if (!$('.shopping-cart-menu .cart-container').length) {
				return frappe.call({
					type: "POST",
					method: 'aracwebshop.aracwebshop.shopping_cart.cart.get_shopping_cart_menu',
					callback: function(r) {
						if (r.message) {
							$('.shopping-cart-menu').html(r.message);
						}
					}
				});
			}
		});
	},

	is_cart_limit_error: function(message) {
		if (!message || typeof message !== "string") return false;
		const text = message.replace(/<[^>]*>?/gm, "").toLowerCase();

		return (
			text.includes("exceeds stock") ||
			text.includes("available in stock") ||
			text.includes("cart quantity remains") ||
			text.includes("maximum allowed") ||
			text.includes("only can order") ||
			text.includes("max qty")
		);
	},

	get_cart_limit_warning_label: function(message) {
		if (!message || typeof message !== "string") return __("Max Reached");

		const cleanMessage = message.replace(/<[^>]*>?/gm, "").trim();
		const text = cleanMessage.toLowerCase();

		if (text.includes("exceeds stock") || text.includes("available in stock")) {
			return __("Stock Limit Reached");
		}
		if (
			text.includes("maximum allowed") ||
			text.includes("only can order") ||
			text.includes("max qty")
		) {
			return __("Max Qty Reached");
		}
		if (cleanMessage.length < 35) {
			return cleanMessage;
		}

		return __("Max Reached");
	},

	escape_html: function(value) {
		const text = value == null ? "" : String(value);
		if (typeof frappe !== "undefined" && frappe.utils && frappe.utils.escape_html) {
			return frappe.utils.escape_html(text);
		}
		return text
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/"/g, "&quot;")
			.replace(/'/g, "&#39;");
	},

	get_item_toast_name: function(item_code, $trigger) {
		const clean = (value) => (value == null ? "" : String(value).replace(/\s+/g, " ").trim());
		const candidates = [];

		if ($trigger && $trigger.length) {
			const $detailPanel = $trigger.closest(".item-details-panel");
			const $card = $trigger.closest(".item-card, .wishlist-card, .list-row, .product-card, .product-container, .card");
			const $cart = $trigger.closest(".item-cart");
			const $variantRow = $trigger.closest(".arac-variant-row, .arac-variant-table-row");

			candidates.push(
				$variantRow.attr("data-item-name"),
				$variantRow.find(".arac-variant-name").first().text(),
				$detailPanel.find(".item-product-title").first().text(),
				$detailPanel.find('[itemprop="name"]').first().text(),
				$card.find("h3").first().text(),
				$card.find('[itemprop="name"]').first().text(),
				$cart.attr("data-item-name"),
				$card.attr("data-item-name")
			);
		}

		if (item_code) {
			const $matchingCard = $(".item-card, .wishlist-card, .list-row").filter(function() {
				return clean($(this).attr("data-item-code") || $(this).data("item-code")) === clean(item_code);
			}).first();

			candidates.push(
				$matchingCard.find("h3").first().text(),
				$matchingCard.find('[itemprop="name"]').first().text()
			);
		}

		for (const candidate of candidates) {
			const name = clean(candidate);
			if (name) return name;
		}

		return clean(item_code) || __("Item");
	},

	show_add_to_cart_toast: function(opts={}) {
		const itemName = opts.item_name || shopping_cart.get_item_toast_name(opts.item_code, opts.$trigger);
		const message = itemName
			? __("{0} added to cart", [itemName])
			: __("Item added to cart");
		const escapedMessage = shopping_cart.escape_html(message);

		clearTimeout(shopping_cart._add_to_cart_toast_timer);
		$(".arac-cart-add-toast").remove();

		const isDarkMode = (
			document.documentElement.classList.contains("arac-dark") ||
			document.documentElement.getAttribute("data-theme") === "dark" ||
			document.documentElement.getAttribute("data-theme-mode") === "dark" ||
			document.body.classList.contains("arac-dark") ||
			document.body.getAttribute("data-theme") === "dark"
		);
		const toastTheme = isDarkMode ? {
			background: "rgba(31, 31, 36, 0.96)",
			color: "#ffffff",
			border: "1px solid rgba(255, 255, 255, 0.08)",
			shadow: "0 18px 48px rgba(15, 23, 42, 0.28), 0 2px 8px rgba(15, 23, 42, 0.18)",
			iconShadow: "inset 0 0 0 1px rgba(255, 255, 255, 0.24)"
		} : {
			background: "rgba(255, 255, 255, 0.96)",
			color: "#0f172a",
			border: "1px solid rgba(15, 23, 42, 0.10)",
			shadow: "0 18px 48px rgba(15, 23, 42, 0.14), 0 2px 8px rgba(15, 23, 42, 0.08)",
			iconShadow: "0 6px 16px rgba(34, 197, 94, 0.22), inset 0 0 0 1px rgba(255, 255, 255, 0.34)"
		};

		const toastStyle = [
			"position: fixed",
			"top: calc(env(safe-area-inset-top, 0px) + 76px)",
			"left: 50%",
			"z-index: 2147483000",
			"display: flex",
			"align-items: center",
			"gap: 12px",
			"width: max-content",
			"max-width: calc(100vw - 24px)",
			"padding: 12px 16px",
			"border-radius: 8px",
			`background: ${toastTheme.background}`,
			`color: ${toastTheme.color}`,
			`border: ${toastTheme.border}`,
			`box-shadow: ${toastTheme.shadow}`,
			"backdrop-filter: blur(14px)",
			"-webkit-backdrop-filter: blur(14px)",
			"font-size: 14px",
			"font-weight: 500",
			"line-height: 1.35",
			"letter-spacing: 0",
			"opacity: 0",
			"transform: translate(-50%, -10px) scale(0.98)",
			"transition: opacity 180ms ease, transform 180ms ease"
		].join("; ");

		const iconStyle = [
			"width: 20px",
			"height: 20px",
			"min-width: 20px",
			"border-radius: 9999px",
			"background: #52d96b",
			"display: inline-flex",
			"align-items: center",
			"justify-content: center",
			`box-shadow: ${toastTheme.iconShadow}`
		].join("; ");

		const messageStyle = [
			"display: block",
			"max-width: min(390px, calc(100vw - 80px))",
			"overflow-wrap: anywhere"
		].join("; ");

		const $toast = $(`
			<div class="arac-cart-add-toast" role="status" aria-live="polite" style="${toastStyle}">
				<span aria-hidden="true" style="${iconStyle}">
					<svg width="13" height="13" viewBox="0 0 20 20" fill="none">
						<path d="M5 10.4l3.2 3.1L15.2 6" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
				</span>
				<span style="${messageStyle}">${escapedMessage}</span>
			</div>
		`);

		$("body").append($toast);
		requestAnimationFrame(() => {
			$toast.css({
				opacity: "1",
				transform: "translate(-50%, 0) scale(1)"
			});
		});

		shopping_cart._add_to_cart_toast_timer = setTimeout(() => {
			$toast.css({
				opacity: "0",
				transform: "translate(-50%, -8px) scale(0.98)"
			});
			setTimeout(() => {
				$toast.remove();
			}, 220);
		}, 2800);
	},

	queue_cart_update: function(opts) {
		const originalCallback = opts.callback;
		const originalError = opts.error;

		shopping_cart._cart_update_queue = (shopping_cart._cart_update_queue || Promise.resolve())
			.catch(() => {})
			.then(() => new Promise((resolve) => {
				const queuedOpts = Object.assign({}, opts, {
					__from_cart_queue: true,
					callback: function(r) {
						if (typeof originalCallback === "function") {
							originalCallback(r);
						}
						resolve(r);
					},
					error: function(r) {
						if (typeof originalError === "function") {
							originalError(r);
						}
						resolve(r);
					}
				});

				try {
					shopping_cart.update_cart(queuedOpts);
				} catch (err) {
					console.error("[CART] Queued cart update failed:", err);
					if (typeof originalError === "function") {
						originalError(err);
					}
					resolve(err);
				}
			}));

		return shopping_cart._cart_update_queue;
	},

	update_cart: function(opts) {


		if (frappe.session.user==="Guest") {
			if (localStorage) {
				localStorage.setItem("last_visited", window.location.pathname);
			}
			frappe.call('aracwebshop.aracwebshop.api.get_guest_redirect_on_action').then((res) => {
				window.location.href = res.message || "/login";
			});
		} else {
			if (!opts.__from_cart_queue) {
				return shopping_cart.queue_cart_update(opts);
			}

			const shouldFreeze = opts.freeze !== false;
			if (shouldFreeze) shopping_cart.freeze();
			return frappe.call({
				type: "POST",
				method: "aracwebshop.aracwebshop.shopping_cart.cart.update_cart",
					args: {
						item_code: opts.item_code,
						qty: opts.qty,
	                    uom: opts.uom || null,
						additional_notes: opts.additional_notes !== undefined ? opts.additional_notes : undefined,
						with_items: opts.with_items || 0,
						warehouse: opts.warehouse || null
					},
				btn: opts.btn,
				suppress_exception: true,
				callback: function(r) {
					if (shouldFreeze) shopping_cart.unfreeze();

					const msg = r.message || {};
					if (r.exc || msg.status === "error") {
						shopping_cart.reset_overlay_container(opts.item_code);

						let error_msg = msg.message || r.exc || "";
						if (typeof error_msg === "object") {
							error_msg = JSON.stringify(error_msg);
						}
						const is_limit_error =
							shopping_cart.is_cart_limit_error(error_msg) ||
							msg.current_qty !== undefined ||
							msg.projected_qty !== undefined;
						const lowercase_msg = error_msg.toLowerCase();
						const is_internal =
							lowercase_msg.includes("price") ||
							lowercase_msg.includes("rate") ||
							lowercase_msg.includes("purchase") ||
							lowercase_msg.includes("valuation") ||
							lowercase_msg.includes("settings") ||
							lowercase_msg.includes("mysql") ||
							lowercase_msg.includes("database") ||
							lowercase_msg.includes("traceback");

						if (is_internal || r.exc) {
							error_msg = __("This item is currently unavailable. Please contact support.");
						}

						if (!(opts.suppress_limit_dialog && is_limit_error && !is_internal && !r.exc)) {
							if (
								typeof shopping_cart.show_cart_update_error === "function"
								&& opts.cart_row
								&& opts.cart_row.length
							) {
								shopping_cart.show_cart_update_error(
									error_msg || __("Could not update cart."),
									opts
								);
							} else {
								frappe.msgprint(error_msg || __("Could not update cart."));
							}
						}

						const $input = opts.cart_row && opts.cart_row.length
							? opts.cart_row.find(`.cart-qty[data-item-code="${opts.item_code}"]`)
							: $(`.cart-qty[data-item-code="${opts.item_code}"]`);
						if ($input.length) {
							const prev = $input.data("prev");
							if (typeof prev !== "undefined") {
								$input.val(prev);
							}
						}

						if (opts.callback)
							opts.callback(r);

						return;
					}

					shopping_cart.set_cart_count(true);
					if (opts.callback)
						opts.callback(r);
				},
				error: function(r){
					if (shouldFreeze) shopping_cart.unfreeze();
					shopping_cart.reset_overlay_container(opts.item_code);

					let error_msg = __("This item is currently unavailable. Please contact support.");
					try {
						if (r && r.responseText) {
							let json = JSON.parse(r.responseText);
							if (json && json._server_messages) {
								let server_msgs = JSON.parse(json._server_messages);
								let txt = server_msgs.map(m => {
									try {
										let parsed = JSON.parse(m);
										return parsed.message || parsed;
									} catch(e) {
										return m;
									}
								}).join("\n");

								if (txt) {
									const lowercase_txt = txt.toLowerCase();
									const is_internal =
										lowercase_txt.includes("price") ||
										lowercase_txt.includes("rate") ||
										lowercase_txt.includes("purchase") ||
										lowercase_txt.includes("valuation") ||
										lowercase_txt.includes("settings") ||
										lowercase_txt.includes("mysql") ||
										lowercase_txt.includes("database") ||
										lowercase_txt.includes("traceback");

									if (!is_internal) {
										error_msg = txt;
									}
								}
							}
						}
					} catch(err) {
						console.error("Error parsing response message:", err);
					}

					if (
						typeof shopping_cart.show_cart_update_error === "function"
						&& opts.cart_row
						&& opts.cart_row.length
					) {
						shopping_cart.show_cart_update_error(error_msg, opts);
					} else {
						frappe.msgprint({
							title: __("Note"),
							message: error_msg,
							indicator: "red"
						});
					}

					if (opts.error) {
						opts.error(r);
					}
				}
			});
		}
	},

	reset_overlay_container: function(item_code) {
		$('.cart-btn-overlay-container .btn-cart-loading').addClass('hidden');
		if (!item_code) return;
		$(`.cart-btn-overlay-container[data-item-code="${item_code}"]`).each(function() {
			const $container = $(this);
			const $circle = $container.find('.btn-add-to-cart-circle');
			const $loading = $container.find('.btn-cart-loading');
			const $collapsed = $container.find('.btn-cart-collapsed');
			const $pill = $container.find('.btn-cart-pill-expanded');

			$loading.addClass('hidden');
			$pill.addClass('hidden').removeClass('flex');

			const currentQty = parseInt($collapsed.attr('data-qty') || '0', 10);
			if (currentQty === 0) {
				$circle.removeClass('hidden');
				$collapsed.addClass('hidden');
			} else {
				$circle.addClass('hidden');
				$collapsed.removeClass('hidden');
			}
		});
	},

	animate_count_change: function($badges, direction="up", on_complete=null) {
		const old_completion_timer = $badges.first().data("count-animation-complete-timer");
		if (old_completion_timer) {
			clearTimeout(old_completion_timer);
			$badges.removeData("count-animation-complete-timer");
		}

		const reduce_motion = window.matchMedia
			&& window.matchMedia("(prefers-reduced-motion: reduce)").matches;
		if (reduce_motion) {
			$badges.removeClass("animate-count-up animate-count-down");
			if (typeof on_complete === "function") {
				on_complete();
			}
			return;
		}

		const animation_class = direction === "down"
			? "animate-count-down"
			: "animate-count-up";

		$badges.each(function() {
			const badge = this;
			const old_timer = $(badge).data("count-animation-timer");
			if (old_timer) {
				clearTimeout(old_timer);
			}

			badge.classList.remove("animate-count-up", "animate-count-down");
			void badge.offsetWidth;
			badge.classList.add(animation_class);

			const timer = setTimeout(() => {
				badge.classList.remove("animate-count-up", "animate-count-down");
				$(badge).removeData("count-animation-timer");
			}, 560);
			$(badge).data("count-animation-timer", timer);
		});

		if (typeof on_complete === "function") {
			const completion_timer = setTimeout(() => {
				on_complete();
				$badges.removeData("count-animation-complete-timer");
			}, 560);
			$badges.data("count-animation-complete-timer", completion_timer);
		}
	},

	set_cart_count: function(animate=false) {
		$(".intermediate-empty-cart").remove();

		var cart_count = frappe.get_cookie("cart_count");
		if(frappe.session.user==="Guest") {
			cart_count = 0;
		}
		const next_count = parseInt(cart_count || 0, 10) || 0;

		if(cart_count) {
			$(".shopping-cart").toggleClass('hidden', false);
		}

		var $badge = $("#cart-count, #cart-count-mobile, #mobile-nav-cart-count");
		$badge.attr({ role: "status", "aria-live": "polite", "aria-atomic": "true" });
		const previous_count = parseInt($badge.first().text() || 0, 10) || 0;
		const count_direction = next_count < previous_count ? "down" : "up";

		if(next_count === 0) {
			if (window.location.pathname === "/cart") {
				$(".cart-tax-items").hide();
				$(".btn-place-order").hide();
				$(".cart-payment-addresses").hide();

				let intermediate_empty_cart_msg = `
					<div class="text-center w-100 intermediate-empty-cart mt-4 mb-4 text-muted">
						${ __("Cart is Empty") }
					</div>
				`;
				$(".cart-table").after(intermediate_empty_cart_msg);
			}

			if (animate && previous_count > 0) {
				$badge.text('0').removeClass('hidden');
				shopping_cart.animate_count_change($badge, "down", () => {
					$badge.addClass('hidden');
				});
			} else {
				$badge.removeClass("animate-count-up animate-count-down").addClass('hidden').text('0');
			}
		}
		else {
			$badge.text(next_count).removeClass('hidden');

			if (animate) {
				shopping_cart.animate_count_change($badge, count_direction);
				const $bottomCartIcon = $('#mobile-bottom-nav [data-path="cart"] .nav-icon-wrapper');
				$bottomCartIcon.removeClass("animate-cart-bounce");
				if ($bottomCartIcon.length) {
					void $bottomCartIcon[0].offsetWidth;
					$bottomCartIcon.addClass("animate-cart-bounce");
				}

				setTimeout(() => {
					$bottomCartIcon.removeClass("animate-cart-bounce");
				}, 560);
			}
		}
	},

	shopping_cart_update: function({ item_code, qty, uom, conversion_factor, warehouse, cart_dropdown, additional_notes, cart_row, callback}) {
		const $pendingRows = cart_row && cart_row.length ? cart_row : $(".cart-item-card").filter(function() {
			return String($(this).attr("data-item-code") || "") === String(item_code || "");
		});
		const $pendingControls = $pendingRows.find("button, input, textarea, select");
		$pendingRows
			.attr("aria-busy", "true")
			.addClass("opacity-60 pointer-events-none");
		$pendingControls.prop("disabled", true);

		const clearPendingState = () => {
			$pendingRows
				.removeAttr("aria-busy")
				.removeClass("opacity-60 pointer-events-none");
			$pendingControls.prop("disabled", false);
		};

		shopping_cart.update_cart({
			item_code,
			qty,
			uom: uom || null,
			conversion_factor: conversion_factor || null,
			warehouse: warehouse || null,
			additional_notes,
			cart_row: $pendingRows,
			with_items: 1,
			freeze: false,
			btn: this,
			callback: function(r) {
				const msg = r.message || {};
				if(!r.exc && msg.status !== "error") {
					$(".cart-items").html(r.message.items);
					$(".cart-tax-items").html(r.message.total);
					$(".payment-summary").html(r.message.taxes_and_totals);
					shopping_cart.set_cart_count(true);

					if (typeof shopping_cart.check_stock_warnings === "function") {
						shopping_cart.check_stock_warnings();
					}

					if (cart_dropdown != true) {
						$(".cart-icon").hide();
					}
				} else {
					clearPendingState();
				}
				// Only run caller hook when one was provided.
				if (typeof callback === "function") callback(r);
			},
			error: function(r) {
				clearPendingState();
				if (typeof callback === "function") callback(r);
			},
		});
	},

	show_cart_navbar: function () {
		// Server pre-renders navbar state directly in Jinja HTML to avoid client-side layout flashing
	},

	toggle_button_class(button, remove, add) {
		button.removeClass(remove);
		button.addClass(add);
	},

	bind_add_to_cart_action() {
		$('.page_content').off('click.shopping_cart_list', '.btn-add-to-cart-list')
			.on('click.shopping_cart_list', '.btn-add-to-cart-list', (e) => {
			const $btn = $(e.currentTarget);
			$btn.prop('disabled', true);

			if (frappe.session.user==="Guest") {
				if (localStorage) {
					localStorage.setItem("last_visited", window.location.pathname);
				}
				frappe.call('aracwebshop.aracwebshop.api.get_guest_redirect_on_action').then((res) => {
					window.location.href = res.message || "/login";
				});
				return;
			}

			$btn.addClass('hidden');
			$btn.closest('.cart-action-container').addClass('d-flex');
			$btn.parent().find('.go-to-cart').removeClass('hidden');
			$btn.parent().find('.go-to-cart-grid').removeClass('hidden');
			$btn.parent().find('.cart-indicator').removeClass('hidden');

			const item_code = $btn.data('item-code');

// ✅ find the card
const $card = $btn.closest('.item-card');

// ✅ read selected uom
let uom = null;
let conversion_factor = null;

const $uomSelect = $card.find(`.uom-select[data-item-code="${item_code}"]`);
if ($uomSelect.length) {
  const $opt = $uomSelect.find('option:selected');
  uom = $uomSelect.val();
  conversion_factor = $opt.data('conversion');
} else {
  const $hiddenUom = $card.find(`.selected-uom[data-item-code="${item_code}"]`);
  uom = $hiddenUom.val();
  conversion_factor = $hiddenUom.data('conversion');
}

aracwebshop.aracwebshop.shopping_cart.update_cart({
  item_code,
  qty: 1,
  uom: uom,
  conversion_factor: conversion_factor,
  $trigger: $btn,
  callback: function (r) {
  const msg = r.message || {};
  if (r.exc || msg.status === "error") {
    $btn.prop('disabled', false).removeClass('disabled').removeClass('hidden');
    const $scope = $btn.closest('.item-card, .product-card, .list-row, .cart-action-container, .product-container, .card');
    $scope.find('.go-to-cart, .go-to-cart-grid').addClass('hidden');
    $scope.find('.cart-indicator').addClass('hidden');
    return;
  }

  // 1) Find the nearest “product container” (card / row / whatever)
  const $scope = $btn.closest('.item-card, .product-card, .list-row, .cart-action-container, .product-container, .card');

  // 2) Update cart badge ONLY if it exists
  const $indicator = $scope.find(`.cart-indicator[data-item-code="${item_code}"]`);
  if ($indicator.length) {
    $indicator.removeClass('hidden');

    // If you have the new span:
    const $count = $indicator.find('.cart-indicator-count');
    if ($count.length) {
      const current = parseInt(($count.text() || "0").trim(), 10) || 0;
      $count.text(current > 0 ? current : 1);   // or (current + 1)
    } else {
      // Backward compatible: if old markup was just "1"
      $indicator.text("1");
    }
  }

  // 3) Toggle Go-to-cart buttons ONLY if they exist
  const $goToCart = $scope.find('.go-to-cart, .go-to-cart-grid');
  if ($goToCart.length) $goToCart.removeClass('hidden');

  // 4) Hide Add button ONLY if it exists
  if ($btn && $btn.length) $btn.addClass('hidden');

  // 5) Re-enable button (if you disabled it)
  $btn.prop('disabled', false).removeClass('disabled');
  shopping_cart.show_add_to_cart_toast({ item_code, $trigger: $btn });
}
		});
		}); // Close original click handler

		// Helper functions to show and collapse expanded pill with smooth full-width expansion & 4s timer
		const resetPillInactivityTimer = ($container) => {
			if ($container.data('pill-timer')) {
				clearTimeout($container.data('pill-timer'));
			}
			const timer = setTimeout(() => {
				collapsePillController($container);
			}, 4000);
			$container.data('pill-timer', timer);
		};

		const showPillController = ($container) => {
			$container.data('just-opened', true);
			setTimeout(() => {
				$container.removeData('just-opened');
			}, 350);

			$('.cart-btn-overlay-container').not($container).each(function() {
				collapsePillController($(this));
			});

			const $circle = $container.find('.btn-add-to-cart-circle');
			const $collapsed = $container.find('.btn-cart-collapsed');
			const $pill = $container.find('.btn-cart-pill-expanded');

			$container.addClass('is-expanded-pill');
			$circle.addClass('hidden');
			$collapsed.addClass('hidden');
			$pill.removeClass('hidden').addClass('flex');

			resetPillInactivityTimer($container);
		};

		const collapsePillController = ($container) => {
			if ($container.data('just-opened')) {
				return;
			}

			if ($container.data('pill-timer')) {
				clearTimeout($container.data('pill-timer'));
				$container.removeData('pill-timer');
			}

			const qty = parseInt($container.find('.input-cart-qty').val() || '0', 10);
			const $circle = $container.find('.btn-add-to-cart-circle');
			const $collapsed = $container.find('.btn-cart-collapsed');
			const $pill = $container.find('.btn-cart-pill-expanded');

			$container.removeClass('is-expanded-pill');
			$pill.addClass('hidden').removeClass('flex');

			if (qty > 0) {
				$collapsed.removeClass('hidden');
				$circle.addClass('hidden');
			} else {
				$circle.removeClass('hidden');
				$collapsed.addClass('hidden');
			}
		};

		// Synchronize all overlay instances for an item code across the document
		const syncCartOverlays = (item_code, qty) => {
			const targetQty = parseInt(qty || 0, 10);
			const $containers = $(`.cart-btn-overlay-container[data-item-code="${item_code}"]`);

			$containers.each(function() {
				const $container = $(this);
				const $circle = $container.find('.btn-add-to-cart-circle');
				const $loading = $container.find('.btn-cart-loading');
				const $collapsed = $container.find('.btn-cart-collapsed');
				const $pill = $container.find('.btn-cart-pill-expanded');
				const $display = $container.find('.cart-qty-display');
				const $input = $pill.find('.input-cart-qty');

				$loading.addClass('hidden');
				$display.text(targetQty);
				$input.val(targetQty);
				$collapsed.attr('data-qty', targetQty);

				if ($pill.hasClass('flex')) {
					if (targetQty <= 0) {
						collapsePillController($container);
					}
				} else {
					if (targetQty <= 0) {
						$pill.addClass('hidden').removeClass('flex');
						$collapsed.addClass('hidden');
						$circle.removeClass('hidden');
					} else {
						$circle.addClass('hidden');
						$collapsed.removeClass('hidden');
						$pill.addClass('hidden').removeClass('flex');
					}
				}
			});
		};

		const setCartOverlayPending = (item_code, isPending) => {
			const $containers = $(`.cart-btn-overlay-container[data-item-code="${item_code}"]`);
			$containers.toggleClass('is-cart-update-pending', isPending);
			if (isPending) {
				$containers.attr('aria-busy', 'true');
			} else {
				$containers.removeAttr('aria-busy');
			}
			$containers.find('.btn-cart-pill-expanded button').prop('disabled', isPending);
		};

		// Floating Warning Toast for Max Quantity & Stock Validation Limits
		const showStockWarningToast = ($container, message) => {
			$container.find('.cart-stock-warning-toast').remove();

			const displayMsg = shopping_cart.get_cart_limit_warning_label(message);

			const $toast = $(`
				<div class="cart-stock-warning-toast absolute -top-10 right-0 rtl:right-auto rtl:left-0 bg-amber-500 text-white text-[10px] md:text-xs font-black px-3 py-1 rounded-full shadow-xl z-30 whitespace-nowrap animate-bounce flex items-center gap-1" style="background-color: #f59e0b !important; color: #ffffff !important;">
					<svg class="w-3.5 h-3.5 fill-current text-white shrink-0" viewBox="0 0 20 20">
						<path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
					</svg>
					<span>${displayMsg}</span>
				</div>
			`);

			$container.append($toast);

			setTimeout(() => {
				$toast.fadeOut(300, function() { $(this).remove(); });
			}, 2800);
		};

		// Circular Plus Button Handler (Initial state)
		$(document).off('click.overlay_cart', '.btn-add-to-cart-circle')
				   .on('click.overlay_cart', '.btn-add-to-cart-circle', (e) => {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();

			const $btn = $(e.currentTarget);
			const item_code = $btn.data('item-code');
			const $container = $btn.closest('.cart-btn-overlay-container');

			if (frappe.session.user === "Guest") {
				if (localStorage) {
					localStorage.setItem("last_visited", window.location.pathname);
				}
				frappe.call('aracwebshop.aracwebshop.api.get_guest_redirect_on_action').then((res) => {
					window.location.href = res.message || "/login";
				});
				return;
			}

			// Instant Frontend Stock Check
			const maxQtyAttr = $container.attr('data-max-qty');
			const stockQtyAttr = $container.attr('data-stock-qty');
			const allowOutOfStock = $container.attr('data-allow-out-of-stock') === 'true';

			if (maxQtyAttr && maxQtyAttr !== '') {
				const maxQty = parseFloat(maxQtyAttr);
				if (maxQty > 0 && 1 > maxQty) {
					showStockWarningToast($container, __("Max Qty Reached"));
					return;
				}
			}
			if (!allowOutOfStock && stockQtyAttr && stockQtyAttr !== '') {
				const stockQty = parseFloat(stockQtyAttr);
				if (stockQty > 0 && 1 > stockQty) {
					showStockWarningToast($container, __("Stock Limit Reached"));
					return;
				}
			}

			const $card = $btn.closest('.item-card');
			let uom = null;
			let conversion_factor = null;

			const $uomSelect = $card.find(`.uom-select[data-item-code="${item_code}"]`);
			if ($uomSelect.length) {
				const $opt = $uomSelect.find('option:selected');
				uom = $uomSelect.val();
				conversion_factor = $opt.data('conversion');
			} else {
				const $hiddenUom = $card.find(`.selected-uom[data-item-code="${item_code}"]`);
				uom = $hiddenUom.val();
				conversion_factor = $hiddenUom.data('conversion');
			}

			// Reflect the expected result immediately while the server remains the
			// source of truth. Controls stay locked until validation completes.
			syncCartOverlays(item_code, 1);
			showPillController($container);
			setCartOverlayPending(item_code, true);

			aracwebshop.aracwebshop.shopping_cart.update_cart({
				item_code,
				qty: 1,
				uom: uom,
				conversion_factor: conversion_factor,
				$trigger: $btn,
				suppress_limit_dialog: true,
				callback: function (r) {
					setCartOverlayPending(item_code, false);
					const msg = r.message || {};
					if (r.exc || msg.status === "error") {
						const confirmedQty = msg.current_qty !== undefined
							? parseInt(msg.current_qty, 10) || 0
							: 0;
						syncCartOverlays(item_code, confirmedQty);
						showStockWarningToast($container, msg.message || r.exc);
						return;
					}
					syncCartOverlays(item_code, 1);
					showPillController($container);
					shopping_cart.show_add_to_cart_toast({ item_code, $trigger: $btn });
				},
				error: function (r) {
					setCartOverlayPending(item_code, false);
					syncCartOverlays(item_code, 0);
					showStockWarningToast($container, __("Error updating cart"));
				}
			});
		});

		// Increase/Decrease Quantity Handlers inside Pill Controller
		const handlePillQtyChange = ($trigger, direction) => {
			const item_code = $trigger.data('item-code');
			const $container = $trigger.closest('.cart-btn-overlay-container');
			const $pill = $container.find('.btn-cart-pill-expanded');
			const $input = $pill.find('.input-cart-qty');
			const currentQty = parseInt($input.val() || '0', 10);
			const targetQty = direction === 'up' ? currentQty + 1 : currentQty - 1;

			if (targetQty < 0) return;

			// Instant Frontend Stock & Max Quantity Check
			if (direction === 'up') {
				const maxQtyAttr = $container.attr('data-max-qty');
				const stockQtyAttr = $container.attr('data-stock-qty');
				const allowOutOfStock = $container.attr('data-allow-out-of-stock') === 'true';

				if (maxQtyAttr && maxQtyAttr !== '') {
					const maxQty = parseFloat(maxQtyAttr);
					if (maxQty > 0 && targetQty > maxQty) {
						showStockWarningToast($container, __("Max Qty Reached"));
						resetPillInactivityTimer($container);
						return;
					}
				}
				if (!allowOutOfStock && stockQtyAttr && stockQtyAttr !== '') {
					const stockQty = parseFloat(stockQtyAttr);
					if (stockQty > 0 && targetQty > stockQty) {
						showStockWarningToast($container, __("Stock Limit Reached"));
						resetPillInactivityTimer($container);
						return;
					}
				}
			}

			// Reset auto collapse timer on interaction (4s soft collapse)
			resetPillInactivityTimer($container);

			$pill.css('pointer-events', 'none');

			const $card = $trigger.closest('.item-card');
			let uom = null;
			let conversion_factor = null;

			const $uomSelect = $card.find(`.uom-select[data-item-code="${item_code}"]`);
			if ($uomSelect.length) {
				const $opt = $uomSelect.find('option:selected');
				uom = $uomSelect.val();
				conversion_factor = $opt.data('conversion');
			} else {
				const $hiddenUom = $card.find(`.selected-uom[data-item-code="${item_code}"]`);
				uom = $hiddenUom.val();
				conversion_factor = $hiddenUom.data('conversion');
			}

			aracwebshop.aracwebshop.shopping_cart.update_cart({
				item_code,
				qty: targetQty,
				uom: uom,
				conversion_factor: conversion_factor,
				suppress_limit_dialog: true,
				callback: function (r) {
					$pill.css('pointer-events', 'auto');
					const msg = r.message || {};
					if (r.exc || msg.status === "error") {
						const errMessage = msg.message || r.exc;
						showStockWarningToast($container, errMessage);
						const validQty = msg.current_qty !== undefined ? parseInt(msg.current_qty, 10) : currentQty;
						syncCartOverlays(item_code, validQty);
						return;
					}
					syncCartOverlays(item_code, targetQty);
				},
				error: function (r) {
					$pill.css('pointer-events', 'auto');
					showStockWarningToast($container, __("Error updating cart"));
					syncCartOverlays(item_code, currentQty);
				}
			});
		};

		$(document).off('click.overlay_cart', '.btn-increase-qty')
				   .on('click.overlay_cart', '.btn-increase-qty', (e) => {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
			handlePillQtyChange($(e.currentTarget), 'up');
		});

		$(document).off('click.overlay_cart', '.btn-decrease-qty')
				   .on('click.overlay_cart', '.btn-decrease-qty', (e) => {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
			handlePillQtyChange($(e.currentTarget), 'down');
		});

		$(document).off('click.overlay_cart', '.btn-cart-collapsed')
				   .on('click.overlay_cart', '.btn-cart-collapsed', (e) => {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
			const $container = $(e.currentTarget).closest('.cart-btn-overlay-container');
			showPillController($container);
		});

		$(document).off('click.overlay_cart', '.btn-cart-pill-expanded')
				   .on('click.overlay_cart', '.btn-cart-pill-expanded', (e) => {
			e.stopPropagation();
			e.stopImmediatePropagation();
		});

		// Collapse if user taps anywhere else outside the container
		$(document).off('click.overlay_cart_outside')
				   .on('click.overlay_cart_outside', (e) => {
			if ($(e.target).closest('.cart-btn-overlay-container').length) return;
			$('.cart-btn-overlay-container').each(function() {
				collapsePillController($(this));
			});
		});
	},

	freeze() {
		if (window.location.pathname !== "/cart") return;

		if (!$('#freeze').length) {
			let freeze = $('<div id="freeze" class="modal-backdrop fade"></div>')
				.appendTo("body");

			setTimeout(function() {
				freeze.addClass("show");
			}, 1);
		} else {
			$("#freeze").addClass("show");
		}
	},

	unfreeze() {
		$('.btn-cart-loading').addClass('hidden');
		if ($('#freeze').length) {
			let freeze = $('#freeze').removeClass("show");
			setTimeout(function() {
				freeze.remove();
			}, 1);
		}
	}
});

// Premium specials offer modal popup helpers
window.show_promo_modal = function(title, detail) {
	$('#arac-promo-modal').remove();

	const modalHtml = `
		<div id="arac-promo-modal" class="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md opacity-0 transition-opacity duration-300">
			<div class="bg-white rounded-2xl md:rounded-3xl max-w-md w-full p-6 shadow-2xl border border-slate-100/80 transform scale-90 transition-transform duration-300 relative">
				<button type="button" class="arac-promo-close absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 rounded-full hover:bg-slate-100 transition-colors cursor-pointer focus:outline-none">
					<svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
						<path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
					</svg>
				</button>
				<div class="flex items-center gap-3 mb-4">
					<div class="w-10 h-10 rounded-xl bg-amber-50 flex items-center justify-center text-amber-500 shrink-0 border border-amber-100">
						<svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
							<path stroke-linecap="round" stroke-linejoin="round" d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
						</svg>
					</div>
					<div>
						<span class="text-[9px] font-black uppercase tracking-widest text-amber-600 block arac-promo-eyebrow"></span>
						<h3 class="text-sm md:text-base font-black text-slate-900 m-0 leading-tight arac-promo-title"></h3>
					</div>
				</div>
				<div class="text-xs md:text-sm text-slate-600 leading-relaxed mb-6 font-medium arac-promo-detail"></div>
				<button type="button" class="arac-promo-close w-full py-2.5 bg-theme-primary hover:bg-theme-primary-hover text-white font-bold rounded-xl shadow-lg shadow-theme-primary/10 hover:shadow-theme-primary/10 transition-all text-xs md:text-sm cursor-pointer select-none">
					<span class="arac-promo-confirm-label"></span>
				</button>
			</div>
		</div>
	`;

	const $modal = $(modalHtml);
	$modal.find('.arac-promo-eyebrow').text(__("Special Offer"));
	$modal.find('.arac-promo-title').text(title == null ? "" : String(title));
	$modal.find('.arac-promo-detail').text(detail == null ? "" : String(detail));
	$modal.find('.arac-promo-confirm-label').text(__("Cool, Got It"));
	$('body').append($modal);

	// Trigger animation frames
	setTimeout(() => {
		$('#arac-promo-modal').removeClass('opacity-0');
		$('#arac-promo-modal > div').removeClass('scale-90');
	}, 10);

	// Close on clicking backdrop
	$('#arac-promo-modal').on('click', function(e) {
		if (e.target === this) {
			window.close_promo_modal();
		}
	});
};

window.close_promo_modal = function() {
	const $modal = $('#arac-promo-modal');
	if ($modal.length) {
		$modal.addClass('opacity-0');
		$modal.children('div').addClass('scale-90');
		setTimeout(() => {
			$modal.remove();
		}, 300);
	}
};

$(document)
	.off('click.arac_promo', '.promo-badge-trigger')
	.on('click.arac_promo', '.promo-badge-trigger', function(e) {
		e.preventDefault();
		e.stopPropagation();
		window.show_promo_modal(
			$(this).attr('data-promo-title') || "",
			$(this).attr('data-promo-detail') || ""
		);
	})
	.off('click.arac_promo_close', '.arac-promo-close')
	.on('click.arac_promo_close', '.arac-promo-close', function(e) {
		e.preventDefault();
		window.close_promo_modal();
	});
